
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/assignment-index/jst/NoAssignmentsSearch';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div>\n  <div class=\"ig-header\">\n    <h2 class=\"ig-header-title\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.no_assignments_search")
  },data:data},helper ? helper.call(depth0, "assignments.no_assignments_search.aria_assignments", "Assignments", options) : helperMissing.call(depth0, "t", "assignments.no_assignments_search.aria_assignments", "Assignments", options)))
    + "\">\n      <i class=\"icon-mini-arrow-down\"></i>\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.no_assignments_search")
  },data:data},helper ? helper.call(depth0, "assignments.no_assignments_search.assignments", "Assignments", options) : helperMissing.call(depth0, "t", "assignments.no_assignments_search.assignments", "Assignments", options)))
    + "\n    </h2>\n  </div>\n  <ul class=\"ig-list\">\n    <li>\n      <div class=\"ig-row ig-row-empty\">\n        <div class=\"ig-empty-msg\">\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.no_assignments_search")
  },data:data},helper ? helper.call(depth0, "assignments.no_assignments_search.no_assignments_found", "No assignments found", options) : helperMissing.call(depth0, "t", "assignments.no_assignments_search.no_assignments_found", "No assignments found", options)))
    + "\n        </div>\n      </div>\n    </li>\n  </ul>\n</div>";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  